module.exports = __webpack_public_path__ + "img/star_half.d34cb091.png";